import { SUBMIT_RESPONSE_SHORTCUT } from '@plugins/client/constants';
import { type SortOption } from '@plugins/client/ssf/types';
import { SortType } from '@plugins/shared/types/sort';

export const COMMENT_DEFAULT_SORT_OPTIONS: SortOption[] = [
  { display: 'postComments.sort.newOld', value: SortType.NEW_OLD },
  { display: 'postComments.sort.oldNew', value: SortType.OLD_NEW },
  { display: 'postComments.sort.popular', value: SortType.POPULAR },
  { display: 'postComments.sort.unpopular', value: SortType.UNPOPULAR },
];

export const DEFAULT_AVATAR_SIZE = '24';
export const DEFAULT_USER_NAME_SIZE = 13;
export const DEFAULT_PICKED_SIZE = '0.875rem';
export { SUBMIT_RESPONSE_SHORTCUT };
